export default "__VITE_ASSET__Be7RXxmN__"